import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AdmintoolLayoutComponent } from './components/admintool-layout/admintool-layout.component';
import { BlacklistComponent } from './components/blacklist/blacklist.component';
import { AdminsComponent } from './components/admins/admins.component';
import { CopyManagementComponent } from './components/copy-management/copy-management.component';
import { StationConfiguratorComponent } from './components/station-configurator/station-configurator.component';
import { ManageCarsComponent } from './components/manage-cars/manage-cars.component';
import { AuthGuard } from './core/auth/auth-guard';
import { AdminPermissionGuard } from './core/guards/admin-permission.guard';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    canActivate: [AuthGuard],
    component: AdmintoolLayoutComponent,
    children: [
      {
        path: 'blacklist',
        component: BlacklistComponent,
        canActivate: [AdminPermissionGuard],
      },
      {
        path: 'admins',
        component: AdminsComponent,
        canActivate: [AdminPermissionGuard],
      },
      {
        path: 'claim-management',
        canActivate: [AdminPermissionGuard],
        loadChildren: () => import('./modules/claim-management-screen/claim-management-screen.module').then((m) => m.ClaimManagementScreenModule),
      },
      // TODO: Add canActivate: [AdminPermissionGuard] when RAC_MANAGEMENT permission is added to backend
      {
        path: 'copy-management',
        component: CopyManagementComponent,
      },
      {
        path: 'station-configurator',
        component: StationConfiguratorComponent,
      },
      {
        path: 'manage-cars',
        component: ManageCarsComponent,
      },
      // TODO: Add canActivate: [AdminPermissionGuard] when RAC_MANAGEMENT permission is added to backend
      {
        path: 'booking-management',
        loadChildren: () => import('./modules/booking-management-screen/booking-management-screen.module').then((m) => m.BookingManagementScreenModule),
      },
      { path: '**', redirectTo: 'claim-management' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
